import React, { useState } from 'react'
import Modal from 'components/Shared/Modal'
import Button from 'components/Shared/Button'

import './NewDashboardModal.scss'

const LOCAL_STORAGE_KEY = 'new-dashboard-modal-seen'

const NewDashboardModal = () => {
  const [hidden, setHidden] = useState(
    () => !!window.localStorage.getItem(LOCAL_STORAGE_KEY)
  )

  if (hidden) {
    return null
  }

  const handleClose = () => {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, '1')
    setHidden(true)
  }

  return (
    <Modal white className="new-dashboard-modal">
      <div className="new-dashboard-modal-content">
        <h2>
          <span role="img" aria-label="sparkles">
            ✨
          </span>{' '}
          Welcome to the new Dashboard!
        </h2>
        <p>
          We've redesigned things to make managing your apps, account, and team
          easier than ever. Take a look around and let us know what you think!
        </p>
        <Button
          large
          teal
          onClick={handleClose}
          className="new-dashboard-modal-button"
        >
          Got it
        </Button>
      </div>
    </Modal>
  )
}

export default NewDashboardModal
